module.exports = __webpack_public_path__ + "img/design-file-pen-alternate.0983c81f.svg";